import React from 'react';
import { Button } from '../ui/Button';
export function WhoWeAreSection() {
  return <section id="about" className="bg-[#F5F5F5] py-20" data-id="element-314">
      <div className="max-w-7xl mx-auto px-4" data-id="element-315">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-316">
          {/* Left - Content */}
          <div data-id="element-317">
            <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-318">
              Who We Are
            </h2>
            <p className="text-gray-700 text-lg mb-6" data-id="element-319">
              At Judah Medical Transport Company, we provide professional
              medical transportation services in Upper Marlboro, Maryland,
              designed to give you peace of mind. Our team prioritizes safety,
              punctuality, and dignity for every patient.
            </p>
            <p className="text-gray-700 text-lg mb-8" data-id="element-320">
              With years of experience in non-emergency medical transportation,
              we understand the unique needs of our patients. From
              wheelchair-accessible vehicles to trained, compassionate drivers,
              we ensure every ride is comfortable, safe, and on time.
            </p>
            <Button variant="primary" size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-321">
              Learn More
            </Button>
          </div>

          {/* Right - Image */}
          <div data-id="element-322">
            <img src="https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&q=80" alt="Medical transport vehicle" className="rounded-lg shadow-xl w-full h-[400px] object-cover" data-id="element-323" />
          </div>
        </div>
      </div>
    </section>;
}